import { render, staticRenderFns } from "./ProgramCard.vue?vue&type=template&id=669d3f97&scoped=true&"
import script from "./ProgramCard.vue?vue&type=script&lang=js&"
export * from "./ProgramCard.vue?vue&type=script&lang=js&"
import style0 from "./ProgramCard.vue?vue&type=style&index=0&id=669d3f97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669d3f97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDialog,VDivider,VIcon,VImg})
